import React from "react";
import TitlePages from "../../../../layout/TitlePages";
import Breadcrumbs from "../../../../layout/Breadcrumbs";
import { convenios2014 } from "../../../../data/Convenios/dataConvenios"; // Importa solo los convenios de 2014

const Convenios2014 = () => {
  return (
    <>
      <div className="margin-bottom-2">
        <Breadcrumbs
          path={[
            { label: "Transparencia", url: "/Convenios" },
            { label: "Convenios", url: "/Convenios" },
            { label: "2014" },
          ]}
        />

        <TitlePages title="Transparencia" subTitle="Convenios 2014" />

        <div className="w-100 mt-3 Content__grid">
          {convenios2014.map((plan) => (
            <div key={plan.id} className="margin-bottom-1">
              <a href={plan.url} target="_blank" rel="noopener noreferrer">
                <img
                  className="img-fluid hover-effect"
                  src={plan.image}
                  alt={"Convenios " + plan.title}
                />
              </a>
              <p className="mt-2">{plan.title.toUpperCase()}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Convenios2014;